import { useIntl, FormattedMessage } from 'react-intl';
import { useDispatch, useSelector, useTabsState } from '_common/hooks';

import { closeAndResetModal } from '_common/modals/ModalsSlice';

import { IntlErrorBoundary, UserCard } from '_common/components';
import { Tabs, Modal, Button } from '@ets/design-system';

import History from './History/History';
import ActiveSession from './ActiveSession/ActiveSession';
import styles from './UserTokensModal.module.scss';

const MODAL = 'UserTokensModal';

const UserTokensModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  // redux
  const isOpen = useSelector((state) => state.modals.open[MODAL]);
  const user = useSelector((state) => state.modals[MODAL].user);
  const { tab, onTabChange } = useTabsState('userTokenHistory');

  const close = () => {
    dispatch(closeAndResetModal(MODAL));
  };

  return (
    <Modal open={!!isOpen} close={close} width="100rem" testId="user-tokens">
      <div className={styles.form}>
        <Modal.Header>
          <FormattedMessage id="USER_TOKEN_HISTORY" />
        </Modal.Header>
        <Modal.Body>
          <div className={`${styles.body}`}>
            <div className={styles.content}>
              <UserCard userId={user.id} size="l" />
              <div className={styles.page}>
                <Tabs value={tab || 'history'} onValueChange={onTabChange}>
                  <Tabs.List>
                    <Tabs.Trigger value="history">
                      {intl.formatMessage({ id: 'TOKEN_HISTORY' })}
                    </Tabs.Trigger>
                    <Tabs.Trigger value="activeSession">
                      {intl.formatMessage({ id: 'ACTIVE_SESSION' })}
                    </Tabs.Trigger>
                  </Tabs.List>
                  <Tabs.Content value="history">
                    <IntlErrorBoundary key="history" size="xl" style={{ margin: '5rem 0' }}>
                      <History />
                    </IntlErrorBoundary>
                  </Tabs.Content>
                  <Tabs.Content value="activeSession">
                    <IntlErrorBoundary key="activeSession" size="xl" style={{ margin: '5rem 0' }}>
                      <ActiveSession />
                    </IntlErrorBoundary>
                  </Tabs.Content>
                </Tabs>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="standard" size="m" onClick={close} testId="close">
            <FormattedMessage id="global.close" />
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default UserTokensModal;
